var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-wrapper-small",class:( _obj = {}, _obj[_vm.loaderAppearance] = true, _obj )},[_c('div',{staticClass:"loading-animation-small"},[_c('lottie',{attrs:{"options":_vm.options}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.loadingContext))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }